// ENVS
export const IS_PROD = process.env.VERCEL_ENV === 'production' || process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
export const IS_STAGING = process.env.NODE_ENV === 'development' || process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'

// Bolt Website config
export const SIMULATION_DOWN = process.env.NEXT_PUBLIC_SIMULATION_DOWN === 'true'
export const PORTAL_URL = process.env.NEXT_PUBLIC_PORTAL_URL as string

// Facebook
export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID as string

// Google
export const GMAPS_API_KEY = process.env.NEXT_PUBLIC_GMAPS_API_KEY
export const GTM_ID = IS_STAGING ? 'GTM-PJR5QWB' : 'GTM-PLCVTWQ'
